import React from 'react';
import { PageSEO } from '../PageSEO';
import { LegalPageLayout } from './LegalPageLayout';

/**
 * Disclosures — Phase 99A.2 light direction.
 *
 * Legal text preserved verbatim. Only chrome migrated to LegalPageLayout.
 */
export const Disclosures = () => (
  <>
    <PageSEO
      title="Disclosures & Legal — GP Capital"
      description="General information disclosures for the GP Capital platform. No offer or solicitation. Wholesale/sophisticated investor eligibility required."
      path="/disclosures"
      referrerPolicy="strict-origin"
    />
    <LegalPageLayout
      eyebrow="Disclosures"
      titleLead="Important investor"
      titleAccent="disclosures."
      lastUpdated="Last updated: 11 February 2026"
      testId="disclosures-page"
      relatedLinks={[
        { to: '/privacy', label: 'Privacy Policy', testId: 'privacy' },
        { to: '/terms', label: 'Terms of Service', testId: 'terms' },
        { to: '/platform-terms', label: 'Platform Terms', testId: 'platform-terms' },
        { to: '/security', label: 'Security & Responsible Disclosure', testId: 'security' },
        { to: '/trust', label: 'Trust Center', testId: 'trust' },
      ]}
    >
      <p>
        The Services referenced in these Disclosures are operated by <strong>GP CAP Pty Ltd</strong> (ACN 665 155 608) operating as <strong>GP Capital</strong> (&quot;<strong>GP Capital</strong>&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;).
      </p>

      <h2>1) General information only — no advice</h2>
      <p>
        All information is general in nature and is not financial product advice, investment advice, legal advice, tax advice, or credit advice.
      </p>

      <h2>2) No offer or solicitation</h2>
      <p>
        Nothing on this website constitutes an offer to sell or a solicitation of an offer to buy any security, fund interest, or financial product. Any offer, if made, will be made only through formal offering materials and definitive documentation, and only to eligible persons in permitted jurisdictions.
      </p>

      <h2>3) Eligibility and jurisdictional restrictions</h2>
      <p>
        Access to certain information may be restricted by law. This website is intended for institutional/professional/wholesale/accredited or otherwise eligible counterparties. GP Capital may require verification of status/eligibility before providing materials or engaging on specific opportunities.
      </p>

      <h2>4) Australia — wholesale/sophisticated only (where applicable)</h2>
      <p>
        Where materials relate to offers or distribution in Australia, they are intended only for persons who qualify as <strong>wholesale clients</strong> and/or fall within relevant disclosure exemptions (including sophisticated/professional investor pathways), as applicable.
      </p>

      <h2>5) United States — private offerings only (where applicable)</h2>
      <p>
        Where any securities-related opportunity is made available in the United States, it will be offered only pursuant to applicable private offering exemptions and only to eligible investors (e.g., accredited investors where required), and may be subject to verification requirements.
      </p>

      <h2>6) Risk; no guarantee</h2>
      <p>
        Private funding, real estate lending, and special situations investing involve risk, including possible loss of capital. Outcomes are not guaranteed.
      </p>

      <h2>7) Forward-looking statements</h2>
      <p>
        Any forward-looking statements are subject to change and actual outcomes may differ materially.
      </p>

      <h2>8) Confidentiality</h2>
      <p>
        Materials may be confidential and intended only for the recipient. You must not redistribute without GP Capital&apos;s prior written consent.
      </p>

      <h2>9) Conflicts of interest</h2>
      <p>
        GP Capital and its affiliates may have interests that differ from those of counterparties, including through fees, related-party arrangements, co-investments, or other commercial relationships. Any relevant conflicts will be addressed in applicable documentation.
      </p>

      <h2>10) Private funding communications — non-binding</h2>
      <p>
        Any discussion of private funding is indicative only and subject to underwriting, diligence, legal review, approvals, and definitive documentation. Terms are not binding unless agreed in executed documents.
      </p>

      <h2>11) Contact</h2>
      <p>
        For questions about these disclosures: <a href="mailto:info@gp-cap.com">info@gp-cap.com</a>
      </p>
    </LegalPageLayout>
  </>
);

export default Disclosures;
